// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"toggle_toggleSwitch__1FScJ","toggleSlider":"toggle_toggleSlider__uQOU3","toggle-row":"toggle_toggle-row__30l4o"};